export default __webpack_public_path__ + "static/biotin-bb0266fd26337254ac9a9c5b00d42bc2.jpg";